import { render } from "./PasswordPrompt.vue?vue&type=template&id=dff3d6da&ts=true"
import script from "./PasswordPrompt.vue?vue&type=script&lang=ts"
export * from "./PasswordPrompt.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__